import React, { Fragment, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import Label from "../../../components/UI/Label/Label";
import { Button } from "../../../components";
import LabelButton from "../../../components/UI/Label/LabelButton";
import { encodeFileToBase64 } from "../../../modules/utils/encodeFileToBase64/encodeFileToBase64";
import { AppContext, SET_IDCARD_STATE } from "../../../components/AppProvider";
import { getIdCard, openIdCard } from "../Interface/NFTF/NativeApi";
import { IC } from "../../../resources/Assets";
import { addHyphenToPhoneNumber } from "../../../modules/utils/addHyphenToPhoneNumber";

const ReceiptTargetInfo = props => {
  const { phonecfg, userinfo, dispatch, idCardState } = useContext(AppContext);
  const { setPageType, fileTemp, setFileTemp, familyInfo } = props;
  // const [idCard, setIdCard] = useState();
  const pageType = "list";

  const familyData = {
    key: 1,
    name: userinfo.userName,
    birth: userinfo.birth,
    phone: userinfo.userPhone,
    gender: userinfo.sex,
  };

  const [name, setName] = useState(pageType === "add" ? "" : familyData.name);
  const [number, setNumber] = useState(
    pageType === "add" ? "" : familyData.phone
  );
  const [birth, setBirth] = useState(
    pageType === "add" ? "" : familyData.birth
  );
  const [gender, setGender] = useState(
    pageType === "add" ? "" : familyData.gender
  );

  const checkVersion = () => {
    if (phonecfg.phoneOS === "ANDROID") {
      if (parseInt(phonecfg.version.split(".")[2]) > 83) {
        return "notActive";
      } else {
        return "fileData";
      }
    } else {
      if (parseInt(phonecfg.version.split(".")[2]) > 37) {
        return "notActive";
      } else {
        return "fileData";
      }
    }
  };

  const rtnEvent = (value, status) => {
    console.log("11111: ", value, status);
    if (value != "-1") {
      if (status === "1") {
        setFileTemp({
          file: decodeURIComponent(value),
          fileName: familyInfo.famzFileNm + ".jpg",
        });

        // setImgTempView(1);
      } else {
        setFileTemp({
          file: decodeURIComponent(value),
          fileName: familyInfo.famzFileNm + ".jpg",
        });
        setFileTemp({
          file: decodeURIComponent(value),
          fileName: familyInfo.famzFileNm + ".jpg",
        });
      }
    } else {
      setFileTemp({
        file: "",
        fileName: "",
      });
    }
  };

  useEffect(() => {
    // window.NativeInterface = {
    //   getIdCardRtn: (value1, value2) => {
    //     rtnEvent(value1, value2);
    //   },
    // };

    // 진료 신청한 환자의 이름
    if (getIdCard(familyInfo.famzFileNm) === "-1") {
      setFileTemp({ file: "", fileName: "" });
    }
  }, []);

  useEffect(() => {
    console.log("idCardState.reload:: ", idCardState.reload);
    console.log("idCardState:: ", idCardState);
    if (idCardState.reload) {
      console.log("reload true:: ", idCardState);
      if (
        idCardState &&
        idCardState.data &&
        idCardState.data != null &&
        idCardState.data.value1 != "-1"
      ) {
        rtnEvent(idCardState.data.value1, idCardState.data.value2);
      }
      dispatch({
        type: SET_IDCARD_STATE,
        data: { type: "reload" },
      });
    }

    console.log("fileTemp:: ", fileTemp);
  }, [idCardState.reload]);

  return (
    <Fragment>
      <Background>
        <Header>
          <HeaderContent>
            <HeaderTitle>
              {familyInfo.rqstRelCd === "PRCP" && (
                <Label
                  data={{
                    status: "default",
                    text: "본인",
                  }}
                />
              )}
              <HeaderText>{familyInfo.famzNm}</HeaderText>
            </HeaderTitle>

            <Button
              severity="primary_light"
              small={true}
              clickEvent={() => setPageType("list")}>
              <span style={{ padding: "0px 8px" }}>진료대상 변경</span>
            </Button>
          </HeaderContent>
        </Header>
        <Body>
          <BodyContent>
            <div style={{ display: "flex", flexFlow: "column", gap: "4px" }}>
              <TextDiv>
                <BodyTextBold>전화번호</BodyTextBold>
                <BodyText>
                  {addHyphenToPhoneNumber(familyInfo.famzTelNo)}
                </BodyText>
              </TextDiv>
              <TextDiv>
                <BodyTextBold>생년월일</BodyTextBold>
                <BodyText>{familyInfo.famzBirthDt}</BodyText>
              </TextDiv>
            </div>
          </BodyContent>
        </Body>

        <Bottom>
          <input
            type="file"
            id="fileData"
            accept="image/*"
            capture="camera"
            onChange={e => {
              encodeFileToBase64(
                e.target.files, // img or canvas element,
                setFileTemp
              );
            }}
            hidden
          />
          {fileTemp && fileTemp.file != "" && (
            // {idCardState &&
            //   idCardState.data &&
            //   idCardState.data != null &&
            //   idCardState.data.value1 != "-1" && (
            <img
              id="preview"
              src={fileTemp.file}
              // src={decodeURIComponent(idCardState.data.value1)}
              style={{
                width: "100%",
                maxHeight: "400px",
                borderRadius: "6px",
              }}
            />
          )}
          {fileTemp && fileTemp.file != "" ? (
            // {idCardState &&
            // idCardState.data &&
            // idCardState.data != null &&
            // idCardState.data.value1 != "-1" ? (
            <div style={{ display: "flex", alignSelf: "flex-end" }}>
              <LabelButton
                htmlFor={checkVersion()}
                severity="light"
                small={true}
                disable="on"
                clickEvent={() => openIdCard()}>
                신분증 재등록
              </LabelButton>
            </div>
          ) : (
            <LabelButton
              htmlFor={checkVersion()}
              severity="light"
              disable="on"
              L_ICON={IC.etc.ICON_GRAY_PLUS}
              clickEvent={() => openIdCard()}>
              신분증 등록
            </LabelButton>
          )}
        </Bottom>
      </Background>
      <Notice>
        <NoticeIcon src={IC.notice.ICON_NOTICE_GRAY} />
        <NoticeText>
          수집된 개인정보는 진료 이외의 용도로 사용되지 않습니다.
        </NoticeText>
      </Notice>
    </Fragment>
  );
};

const Background = styled.div`
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  padding: 0;
  border-radius: 10px;
  border: solid 1px #eee;
  background-color: #fff;
`;

const Header = styled.div`
  align-self: stretch;
  flex-grow: 0;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  padding: 20px;
`;

const HeaderContent = styled.div`
  width: 100%;
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`;

const HeaderTitle = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  padding: 0;
`;

const HeaderText = styled.span`
  align-self: stretch;
  flex-grow: 0;
  font-family: Pretendard;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.32px;
  text-align: left;
  color: #333;
`;

const Body = styled.div`
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  gap: 4px;
  padding: 0px 20px 20px;
`;

const BodyContent = styled.div`
  border-top: 1px dashed #e0e0e0;
  padding-top: 20px;
`;

const TextDiv = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  padding: 0;
`;

const BodyTextBold = styled.span`
  flex-grow: 0;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: -0.28px;
  text-align: left;
  color: #333;
`;

const BodyText = styled.span`
  flex-grow: 0;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: -0.28px;
  text-align: left;
  color: #666;
`;

const Bottom = styled.div`
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  gap: 4px;
  padding: 0px 20px 20px;
`;

const Notice = styled.div`
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  padding: 0;
  padding-top: 12px;
`;

const NoticeIcon = styled.img`
  width: 12.8px;
  height: 12.8px;
  flex-grow: 0;
  align-self: flex-start;
`;

const NoticeText = styled.span`
  flex-grow: 0;
  font-family: Pretendard;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: left;
  color: #333;
`;
export default ReceiptTargetInfo;
